export const disableServiceContent = [
  '',
  `mutation disableServiceContent($id:Int!) {
        disableServiceContent(id:$id)
      }
    `,
  'disableServiceContent'];
